import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=51b122a6&scoped=true"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=51b122a6&prod&lang=scss&scoped=true"
import style1 from "./CustomerView.vue?vue&type=style&index=1&id=51b122a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b122a6",
  null
  
)

export default component.exports